// ----- autogen:polyfills:start  -----
//
// ----- autogen:polyfills:end  -----

export { PKPBase } from './lib/pkp-base';
